import { Checkbox, Flex, Icon, Space, Spacing, Text, Tooltip } from '@billy/design-system'
import { ChangeEvent, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

type SiretPendingAssignmentCheckboxProps = {
  checked?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  registrationNoValue?: string
}

export const SiretPendingAssignmentCheckbox = ({
  checked,
  onChange,
  registrationNoValue,
  ...rest
}: SiretPendingAssignmentCheckboxProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Checkbox {...rest} checked={checked} disabled={!!registrationNoValue} onChange={onChange}>
      <Flex alignItems="center" gap={Spacing.S4}>
        <Text variant="bodyMD">{t('external_invoices.company.siret_pending_assignment.checkbox.label')}</Text>
        <Tooltip label={t('external_invoices.company.siret_pending_assignment.checkbox.tooltip')} placement="top">
          <Icon icon="info" size="sm" />
        </Tooltip>
      </Flex>
      <Space size="s10" />
    </Checkbox>
  )
}
